module.exports = __webpack_public_path__ + "static/media/cuellar.c184f786.png";